import { render } from "./TheLoaiHinhDiTichVH.vue?vue&type=template&id=16ec8efa"
import script from "./TheLoaiHinhDiTichVH.vue?vue&type=script&lang=js"
export * from "./TheLoaiHinhDiTichVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__